export const finishTypes = {
    HDP:'finishHdpBets',
    OU:'finishOuBets',
    PARLAY:'finishParlayBets'
}